"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _immutable = require("immutable");

var _createReducer = _interopRequireDefault(require("./createReducer"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var body = {
  isLoading: false,
  request: null,
  response: null,
  error: null
};
/* eslint new-cap: 0 */

var AsyncRequest = new function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function (_Record) {
    (0, _inherits2.default)(_class, _Record);

    var _super = _createSuper(_class);

    function _class() {
      (0, _classCallCheck2.default)(this, _class);
      return _super.apply(this, arguments);
    }

    return (0, _createClass2.default)(_class);
  }((0, _immutable.Record)(_objectSpread(_objectSpread({}, body), state)));
}();
AsyncRequest.body = body;

AsyncRequest.createActionKeys = function (baseActionKey) {
  var _ref;

  return _ref = {}, (0, _defineProperty2.default)(_ref, baseActionKey, baseActionKey), (0, _defineProperty2.default)(_ref, "".concat(baseActionKey, "_ERROR"), "".concat(baseActionKey, "_ERROR")), (0, _defineProperty2.default)(_ref, "".concat(baseActionKey, "_START"), "".concat(baseActionKey, "_START")), (0, _defineProperty2.default)(_ref, "".concat(baseActionKey, "_SUCCESS"), "".concat(baseActionKey, "_SUCCESS")), (0, _defineProperty2.default)(_ref, "".concat(baseActionKey, "_RESET"), "".concat(baseActionKey, "_RESET")), _ref;
};

AsyncRequest.createReducer = function (baseEvent) {
  var otherEventHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new AsyncRequest();
  return (0, _createReducer.default)(initialState, _objectSpread(_objectSpread({}, AsyncRequest.createBaseEventHandlers(baseEvent, initialState)), otherEventHandlers));
};

AsyncRequest.createBaseEventHandlers = function (baseEvent) {
  var _ref2;

  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new AsyncRequest();
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, "".concat(baseEvent, "_START"), function _START(state, action) {
    return AsyncRequest.setStart(state, action.payload);
  }), (0, _defineProperty2.default)(_ref2, "".concat(baseEvent, "_SUCCESS"), function _SUCCESS(state, action) {
    return AsyncRequest.setSuccess(state, action.payload.body);
  }), (0, _defineProperty2.default)(_ref2, "".concat(baseEvent, "_ERROR"), function _ERROR(state, action) {
    return AsyncRequest.setError(state, action.payload);
  }), (0, _defineProperty2.default)(_ref2, "".concat(baseEvent, "_RESET"), function _RESET(state, action) {
    return initialState;
  }), _ref2;
};

AsyncRequest.setStart = function (state, request) {
  var otherProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var newState = _objectSpread({
    isLoading: true,
    request: request
  }, otherProps);

  return _immutable.Iterable.isIterable(state) ? state.merge(newState) : _objectSpread(_objectSpread({}, state), newState);
};

AsyncRequest.setSuccess = function (state, response) {
  var otherProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var newState = _objectSpread({
    isLoading: false,
    response: response,
    error: null
  }, otherProps);

  return _immutable.Iterable.isIterable(state) ? state.merge(newState) : _objectSpread(_objectSpread({}, state), newState);
};

AsyncRequest.setError = function (state, error) {
  var otherProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var newState = _objectSpread({
    isLoading: false,
    response: null,
    error: error
  }, otherProps);

  return _immutable.Iterable.isIterable(state) ? state.merge(newState) : _objectSpread(_objectSpread({}, state), newState);
};

var _default = AsyncRequest;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/AsyncRequest.js
// module id = 360
// module chunks = 25